// extracted by mini-css-extract-plugin
export default {"container":"GeneralSecond_container__x2Dnx","tittle":"GeneralSecond_tittle__dvN37","accHeader":"GeneralSecond_accHeader__kC8yB","collapsed":"GeneralSecond_collapsed__Eh1jl"};